import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import DateService from "../../../Services/Shared/Date.service";
import TrackedMessageService from "../../../Services/TrackedMessage.service";
import CustomCard from "../../UI/CustomCard/CustomCard";
import PagedAndSortedTable from "../../UI/PagedAndSortedTable/PagedAndSortedTable";
import NumberService from "../../../Services/Shared/Number.service";
import LinkToPerson from "../../Presentational/Person/LinkToPerson/LinkToPerson";
import { TotalPageMappers } from "../../Hooks/usePagedSortedTable";
import { useVirtualizedApp } from "../../Hooks/useVirtualizedApp";
import { getCampaignDetailPath } from "../../Pages/Campaign/CampaignRoutes";
const PAGE_SIZE = 20;
const CampaignPerformance = () => {
    const virtualizedAppContext = useVirtualizedApp();
    return (_jsx(CustomCard, { title: "Email Performance Dashboard", className: "mb-3", children: _jsx("div", { className: "card-body", children: _jsx(PagedAndSortedTable, { striped: true, noDataComponent: "No emails", rowVerticalPadding: 2, getData: (sort, pageNumber) => TrackedMessageService.getEventCountsForSources(2, null, null, {
                    max: PAGE_SIZE,
                    offset: pageNumber * PAGE_SIZE,
                    sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                    order: (sort === null || sort === void 0 ? void 0 : sort.order) || null,
                }), initialSort: { sort: "name", order: "asc" }, getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE), columns: [
                    {
                        title: "Name",
                        size: 3,
                        sortId: "name",
                    },
                    { title: "Created By", sortId: "created_by_full_name" },
                    {
                        title: "Started",
                        sortId: "started_date",
                    },
                    {
                        title: "Sent",
                        align: "end",
                        sortId: "sent_count",
                    },
                    {
                        title: "Delivered Rate",
                        align: "end",
                        sortId: "delivered_rate",
                    },
                    {
                        title: "Open Rate",
                        align: "end",
                        sortId: "open_rate",
                    },
                    {
                        title: "Click-Through Rate",
                        align: "end",
                        sortId: "click_through_rate",
                    },
                ], rows: (results) => results.data.map((metric) => {
                    return [
                        _jsx(Link, { 
                            // @ts-expect-error - TS2322 - Type 'number | null | undefined' is not assignable to type 'number | undefined'.
                            to: getCampaignDetailPath({ id: metric.sourceIntId }), children: metric.name }, 0),
                        _jsx(LinkToPerson, { affiliationId: metric.createdByAffiliationId, virtualizedApp: virtualizedAppContext.name, children: metric.createdByFullName }, 1),
                        metric.startedDate
                            ? DateService.display(metric.startedDate)
                            : "Not Started",
                        metric.sentCount || 0,
                        NumberService.asPercentage(metric.deliveredRate || 0) + "%",
                        NumberService.asPercentage(metric.openRate || 0) + "%",
                        NumberService.asPercentage(metric.clickThroughRate || 0) + "%",
                    ];
                }) }) }) }));
};
export default CampaignPerformance;
